import { cn } from "@/lib/utils/cn";

export type ProgressProps = {
  /** 0–100 */
  value: number;
  max?: number;
  label?: string;
  className?: string;
  indicatorClassName?: string;
  indeterminate?: boolean;
};

export function Progress({ value, max = 100, label, className, indicatorClassName, indeterminate }: ProgressProps) {
  const pct = Math.max(0, Math.min(100, (value / max) * 100));
  return (
    <div
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={max}
      aria-valuenow={indeterminate ? undefined : value}
      className={cn("relative h-1.5 w-full overflow-hidden rounded-full bg-surface-2", className)}
    >
      <div
        className={cn("h-full rounded-full bg-accent transition-[width] duration-300", indeterminate && "w-1/3 animate-pulse", indicatorClassName)}
        style={indeterminate ? undefined : { width: `${pct}%` }}
      />
    </div>
  );
}
